module.exports = __webpack_public_path__ + "static/media/siddharth-tirupati-trip-07.3fdad3b0.png";